import { SET_PAGE_HEADING } from './app-action-constants';

export function setPageHeading(pageHeading) {
  return {
    type: SET_PAGE_HEADING,
    pageHeading
  };
}
